<template>
  <ul class="vue-tree fa-ul" v-if="items">
    <template v-for="(item, key) of itemsData" :key="`item${key}`">
      <li
        :class="{
          'hide-children':
            item.is_hidden || item.is_hidden == undefined
              ? item.folder_structure_id == undefined
                ? item.is_hidden
                  ? item.is_hidden
                  : (item.is_hidden = false)
                : (item.is_hidden = true)
              : null,
        }"
      >
        <span
          :class="{
            'fa-li show-on-hover': true,
            'cursor-pointer': !tableCreator && item.folder_structure_id,
          }"
        >
          <button
            type="button"
            class="btn btn-sm btn-light mx-2 my-0"
            @click="
              (item.is_hidden = !item.is_hidden),
                changeItemIsHiddenProperty(item)
            "
            v-if="validateExpandableButton(item)"
          >
            <font-awesome-icon
              :icon="['fas', item.is_hidden ? 'plus' : 'minus']"
              size="xs"
            />
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-faded mx-2 my-0 disabled"
            style="padding: 12px"
          ></button>
          <span @click="showItem(item)">
            <font-awesome-icon
              class="text-warning"
              :icon="['fas', item.icon ? item.icon : 'folder']"
              size="lg"
            />
            {{ item.name }}
            <small v-if="item.files && !tableCreator && item.files.length > 0">
              ({{ item.files.length }} archivo{{
                item.files.length > 1 ? "s" : ""
              }})
            </small>
          </span>
          <span v-if="tableCreator" class="ms-3">
            <Popper
              class="btn btn-sm btn-info m-0 px-3 border-0 hide"
              content="Agregar Carpeta"
              placement="top"
              hover
              arrow
              @click="newItem(item)"
              offsetDistance="35"
            >
              <font-awesome-icon :icon="['fas', 'folder-medical']" />
            </Popper>
            <Popper
              class="btn btn-sm btn-warning m-0 mx-2 px-3 border-0 hide"
              content="Editar Carpeta"
              placement="top"
              hover
              arrow
              @click="editItem(item)"
              offsetDistance="35"
              v-if="item.folder_structure_id"
            >
              <font-awesome-icon :icon="['fas', 'pen-to-square']" />
            </Popper>
            <Popper class="btn btn-sm btn-success m-0 mx-2 px-3 border-0 hide" content="Duplicar carpeta con todas sus subcarpetas" placement="top" hover arrow @click="showModal(item)" offsetDistance="35" v-if="item.folder_structure_id">
              <font-awesome-icon :icon="['fas', 'copy']" />
            </Popper>
            <Popper
              class="btn btn-sm btn-danger m-0 px-3 border-0 hide"
              content="Eliminar Carpeta"
              placement="top"
              hover
              arrow
              @click="item.showDelete = true"
              offsetDistance="35"
              v-if="item.children.length == 0 && item.folder_structure_id"
            >
              <font-awesome-icon :icon="['fas', 'trash-can']" />
            </Popper>
          </span>
          <span
            v-else-if="item.folder_structure_id || item.id == 0"
            class="ms-3"
          >
            <Popper
              v-if="!viewFiles"
              class="btn btn-sm btn-warning m-0 px-3 border-0 hide"
              content="Ver Contenido Carpeta"
              placement="top"
              hover
              arrow
              @click="setFolder(item)"
              offsetDistance="35"
            >
              <font-awesome-icon :icon="['fas', 'folder-open']" />
            </Popper>
            <Popper
              v-if="!item.id == 0"
              class="btn btn-sm btn-info m-0 px-3 border-0 hide mx-2"
              content="Cargar Archivo"
              placement="top"
              hover
              arrow
              @click="newFile(item)"
              offsetDistance="35"
            >
              <font-awesome-icon :icon="['fas', 'file-circle-plus']" />
            </Popper>
          </span>
        </span>
        <div
          v-if="item.showDelete"
          :class="{
            'alert alert-danger alert-dismisable': true,
            'alert-info': !item.isEdit,
            'alert-warning': item.isEdit,
          }"
        >
          <Loading v-if="loading" />
          <template v-if="item.files.length == 0">
            <p class="text-center">
              Por favor confirma que quieres eliminar {{ item.name }}.
            </p>
            <div class="row">
              <div class="col-6 text-end">
                <button
                  type="button"
                  class="btn btn-light my-0"
                  @click="item.showDelete = false"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-danger my-0 me-auto"
                  @click="deleteItem(item)"
                >
                  <font-awesome-icon :icon="['fas', 'trash-can']" /> Eliminar
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              No se puede eliminar una carpeta que contenga archivos.
            </p>
            <div class="col-6 text-end">
              <button
                type="button"
                class="btn btn-light my-0"
                @click="item.showDelete = false"
              >
                Cerrar
              </button>
            </div>
          </template>
        </div>
        <div
          v-if="item.showForm"
          :class="{
            'alert alert-info alert-dismisable': true,
            'alert-info': !item.isEdit,
            'alert-warning': item.isEdit,
          }"
        >
          <Loading v-if="loading" />
          {{ item.isEdit ? `Editar carpeta ${item.name}` : "Crear carpeta" }}
          <button
            type="button"
            class="btn-close float-end"
            @click="item.showForm = false"
            aria-label="Close"
          ></button>
          <div class="form-floating text-dark my-3">
            <input
              v-model="item.newName"
              type="text"
              class="form-control border-secondary"
            />
            <label for="itemNewName">Nombre</label>
          </div>
          <div class="form-floating text-dark my-3">
            <textarea
              v-model="item.newDescription"
              class="form-control border-secondary"
              placeholder="Leave a comment here"
              style="height: 100px"
            ></textarea>
            <label class="label-form-description" for="formDescription"
              >Descripción</label
            >
          </div>
          <div class="form-floating text-dark my-3">
            <v-select
              v-model="item.newFolderId"
              :reduce="(folder) => folder.id"
              class="form-select border-secondary"
              aria-label="Seleccionar Carpeta padre"
              :options="folderList"
              label="complete_name"
              :clearable="false"
            >
              <template #option="{ complete_name }">
                {{ folderStructureName }}/{{ complete_name }}
              </template>
              <template #selected-option="{ complete_name }">
                {{ folderStructureName }}/{{ complete_name }}
              </template>
            </v-select>
            <label for="itemParent">Seleccionar Carpeta padre</label>
          </div>
          <div class="my-3 row">
            <label class="col-sm-6 col-form-label">Ícono carpeta</label>
            <div class="col-sm-6">
              <v-select
                class="bg-white border-secondary"
                v-model="item.newIcon"
                :options="options"
                label="icon"
                :reduce="(icon) => icon"
                :filterable="false"
                :searchable="false"
                :clearable="false"
              >
                <template #selected-option="{ icon }">
                  <font-awesome-icon
                    class="text-warning"
                    :icon="['fas', icon]"
                    size="lg"
                  />
                </template>
                <template #option="{ icon }">
                  <font-awesome-icon
                    class="text-warning"
                    :icon="['fas', icon]"
                    size="lg"
                  />
                </template>
              </v-select>
            </div>
          </div>
          <button type="button" @click="saveItem(item)" class="btn btn-primary">
            Guardar
          </button>
        </div>
        <Tree
          :items="item.children"
          v-if="item.children"
          :table-creator="tableCreator"
          :show-form="item.showForm"
          :folder-structure-name="folderStructureName"
          :folder-list="folderList"
          :view-files="viewFiles"
          @set-data="setData"
          @set-file="setFile"
          @set-folder="setFolder"
          @set-item="setItem"
          @show-modal="showModal"
        />
        <TreeFile
          v-if="item.files && !tableCreator && viewFiles"
          :items="item.files"
          @set-file="setFile"
        />
      </li>
    </template>
  </ul>
</template>

<script>
import TreeFile from "@/components/TreeFile.vue";
import Loading from "@/components/Loading.vue";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "tree",
  emits: ["setData", "setFile", "setFolder", "newFile", "setItem", "showModal"],
  components: { TreeFile, Loading },
  props: {
    items: { type: Array },
    tableCreator: { default: true },
    folderStructureName: { default: "" },
    folderList: { type: Array },
    viewFiles: { default: false },
  },
  data() {
    return {
      selectedItem: null,
      itemsData: null,
      options: [
        "folder",
        "folder-medical",
        "folders",
        "folder-arrow-down",
        "folder-arrow-up",
        "folder-blank",
        "folder-bookmark",
        "folder-gear",
        "folder-grid",
        "folder-heart",
        "folder-image",
        "folder-minus",
        "folder-music",
        "folder-plus",
        "folder-user",
        "folder-xmark",
        "folder-open",
      ],
      loading: false,
    };
  },
  mounted() {
    this.itemsData = this.items;
    this.displayOpenedFolders();
  },
  methods: {
    ...mapMutations("general", ["setOpenedFolders"]),
    newItem(item) {
      this.selectedItem = item;
      item.isEdit = false;
      item.newIcon = "folder";
      item.newName = null;
      item.newFolderId = item.folder_structure_id ? item.id : null;
      item.folder_structure_id = item.folder_structure_id
        ? item.folder_structure_id
        : item.id;
      item.newDescription = null;
      item.showForm = true;
      item.id = null;
    },
    editItem(item) {
      this.selectedItem = item;
      item.isEdit = true;
      item.newIcon = item.icon;
      item.newName = item.name;
      item.newFolderId = item.folder_id;
      item.newDescription = item.description;
      item.showForm = true;
    },
    deleteItem(item) {
      let app = this;
      this.loading = true;
      this.axios
        .delete(
          `folder_structures/${item.folder_structure_id}/folders/${item.id}`
        )
        .then(() => {
          app.$emit("setData");
          app.loading = false;
        })
        .catch((error) => {
          console.log(error);
          app.loading = false;
        });
    },
    saveItem(item) {
      let saveData = {
        folder: {
          name: item.newName,
          description: item.newDescription,
          icon: item.newIcon,
          folder_id: item.newFolderId,
        },
      };
      let app = this;
      this.loading = true;
      if (item.id) {
        this.axios
          .put(
            `folder_structures/${item.folder_structure_id}/folders/${item.id}`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
            app.loading = false;
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      } else {
        this.axios
          .post(
            `folder_structures/${item.folder_structure_id}/folders`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
            app.loading = false;
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      }
    },
    showItem(item) {
      if (!this.tableCreator && item.folder_structure_id) {
        this.$emit("setItem", item);
      }
    },
    setData() {
      this.$emit("setData");
    },
    setItem(item) {
      this.$emit("setItem", item);
    },
    setFile(item) {
      this.$emit("setFile", item);
    },
    setFolder(item) {
      this.$emit("setFolder", item);
    },
    showModal(item){
      this.$emit('showModal', item);
    },
    newFile(item) {
      let file = { name: null, folder_id: item.id };
      this.$emit("setFile", file);
    },
    validateExpandableButton(item) {
      try {
        if (item.children.length > 0) {
          return true;
        } else {
          if (item.files.length > 0 && !this.tableCreator) {
            return true;
          }
        }
      } catch {
        return false;
      }
    },
    displayOpenedFolders() {
      if (this.itemsData.length) {
        if (this.itemsData[0].folder_structure_id) {
          let displayedFolders = this.getOpenedFolders;
          this.itemsData.forEach((item) => {
            if (item.id in displayedFolders) {
              item.is_hidden = displayedFolders[item.id];
            }
          });
        }
      }
    },
    changeItemIsHiddenProperty(item) {
      if (item.folder_structure_id) {
        let currentDisplayedFolders = this.getOpenedFolders;
        currentDisplayedFolders[item.id] = item.is_hidden;
        this.setOpenedFolders(currentDisplayedFolders);
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getOpenedFolders"]),
  },
};
</script>
